import { render, staticRenderFns } from "./ApprovalHeader.vue?vue&type=template&id=14cd62bf&scoped=true&"
import script from "./ApprovalHeader.vue?vue&type=script&lang=js&"
export * from "./ApprovalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd62bf",
  null
  
)

export default component.exports